const stuIntroduce = () => import('@/views/summer-homework/stu-introduce')
const teaIntroduce = () => import('@/views/summer-homework/tea-introduce')
const teaIntroduceJoin = () => import('@/views/summer-homework/tea-introduce-join')
const stuhome = () => import('@/views/summer-homework/stu-home')
const teahome = () => import('@/views/summer-homework/tea-home')
const teabook = () => import('@/views/summer-homework/tea-book')
const stubook = () => import('@/views/summer-homework/stu-book')
const nohomework = () => import('@/views/summer-homework/no-homework')

export default [
    {
        path: 'stu-introduce',
        component: stuIntroduce,
        meta: {
            title: '假期专题'
        }
    },
    {
        path: 'tea-introduce',
        component: teaIntroduce,
        meta: {
            title: '假期专题'
        }
    },
    {
        path: 'tea-introduce-join',
        component: teaIntroduceJoin,
        meta: {
            title: '假期专题'
        }
    },
    {
        path: 'stuhome',
        component: stuhome,
        meta: {
            title: '假期专题'
        }
    },
    {
        path: 'teahome/:id?',
        component: teahome,
        meta: {
            title: '假期专题'
        }
    },
    {
        path: 'teabook/:id',
        component: teabook,
        meta: {
            title: '假期专题'
        }
    },
    {
        path: 'stubook',
        component: stubook,
        meta: {
            title: '假期专题'
        }
    },
    {
        path: 'nohomework',
        component: nohomework,
        meta: {
            title: '假期专题'
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/summer-homework.js